import { signal } from '@preact/signals';

export const creator = signal<Creator | null>(null);

export const isCreator = signal(false);

export const hasActivePlan = signal(false);
